<!--
 * @Author: QiTianDaSheng
 * @Date: 2023-07-17 10:02:14
 * @Descripttion: 
 * @LastEditors: QiTianDaSheng
 * @LastEditTime: 2023-07-19 20:35:08
-->
<!--
 * @Author: Haotian Zheng
 * @Date: 2023-07-13 19:17:16
 * @Descripttion: 
 * @LastEditors: QiTianDaSheng
 * @LastEditTime: 2023-07-17 16:26:37
-->
<!-- 未登录首页 -->
<template>
    <div class="homeBox">
        <!-- banner部分 -->
        <qff-banner></qff-banner>

        <!--面向用户部分-->
        <!-- <qff-user></qff-user> -->

        <!-- 一体化服务平台提升企业管理效率 -->
        <qff-integration></qff-integration>

        <!-- 核心优势 -->
        <qff-core-advantages></qff-core-advantages>

        <!-- 行业解决方案 -->
        <qff-industry-solutions></qff-industry-solutions>

        <!-- 数字动效 -->
        <qff-number></qff-number>

        <!-- 新闻资讯 -->
        <qff-news-information></qff-news-information>

        <!-- 客户案例 -->
        <qff-customer-stories></qff-customer-stories>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import qffBanner from './components/banner.vue'
import qffIntegration from './components/integration.vue'
import qffCoreAdvantages from './components/coreAdvantages.vue'
import qffIndustrySolutions from './components/industrySolutions.vue'
import qffNumber from './components/number.vue'
import qffNewsInformation from './components/newsInformation.vue'
import qffCustomerStories from './components/customerStories.vue'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    qffBanner,
    qffIntegration,
    qffCoreAdvantages,
    qffIndustrySolutions,
    qffNumber,
    qffNewsInformation,
    qffCustomerStories,
  },
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.homeBox {
  background-color: #fff;
}
</style>
